import { SVGProps } from '../types';
const EthereumIcon = (props: SVGProps) => (
  <svg
    width="46"
    height="32"
    viewBox="0 0 46 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4 0.5H42C43.933 0.5 45.5 2.067 45.5 4V28C45.5 29.933 43.933 31.5 42 31.5H4C2.067 31.5 0.5 29.933 0.5 28V4C0.5 2.067 2.067 0.5 4 0.5Z"
      fill="white"
    />
    <path
      d="M4 0.5H42C43.933 0.5 45.5 2.067 45.5 4V28C45.5 29.933 43.933 31.5 42 31.5H4C2.067 31.5 0.5 29.933 0.5 28V4C0.5 2.067 2.067 0.5 4 0.5Z"
      stroke="#DEDBD4"
    />
    <ellipse cx="22.58" cy="15.9133" rx="10.58" ry="10.58" fill="#6481E7" />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M17.958 16.3438L22.7038 19.1493V8.46906L17.958 16.3438Z"
      fill="white"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M22.7041 8.46906V19.1493L27.4499 16.3438L22.7041 8.46906Z"
      fill="#C1CCF5"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M22.7041 14.1868L17.958 16.3437L22.7038 19.1492L27.4499 16.344L22.7041 14.1868Z"
      fill="#8299EC"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M22.7041 14.1868L17.958 16.3437L22.7038 19.1492L22.7041 14.1868Z"
      fill="#C1CCF5"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M17.958 17.2439L22.7038 23.9318V20.0479L17.958 17.2439Z"
      fill="white"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M22.7041 20.0479V23.9322L27.453 17.2439L22.7041 20.0479Z"
      fill="#C1CCF5"
    />
  </svg>
);

export { EthereumIcon };
